import React from 'react';

const Phone = ({ id = 'phoneIcon', className = '', fillColor = 'primary' }) => {
  return (
    <svg
      id={id}
      className={`fill-${fillColor} ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.95223 2.57246C6.38273 2.14191 6.89986 1.80782 7.46931 1.59236C8.03877 1.37689 8.64753 1.28498 9.25521 1.32271C9.8629 1.36044 10.4556 1.52696 10.994 1.81121C11.5325 2.09547 12.0043 2.49096 12.3782 2.97146L16.7909 8.64671C17.602 9.68621 17.8881 11.0433 17.5679 12.3217L16.2212 17.7108C16.1512 17.9905 16.1548 18.2835 16.2316 18.5613C16.3084 18.8392 16.4559 19.0924 16.6596 19.2963L22.7076 25.3417C22.9115 25.5454 23.1648 25.6929 23.4426 25.7697C23.7205 25.8465 24.0135 25.8501 24.2931 25.7801L29.6796 24.4335C30.3114 24.2757 30.9708 24.2636 31.6079 24.3982C32.2451 24.5328 32.8433 24.8106 33.3572 25.2105L39.0325 29.6231C41.0721 31.2086 41.2611 34.2247 39.4341 36.0491L36.8879 38.5953C35.0687 40.4145 32.3466 41.2151 29.8082 40.3226C23.315 38.0371 17.4197 34.3192 12.5594 29.4446C7.68378 24.5845 3.96496 18.6891 1.67873 12.1957C0.786229 9.65734 1.58685 6.93521 3.40598 5.11346L5.95223 2.56984V2.57246Z"
      />
    </svg>
  );
};
export default Phone;
